import ProductDescription from './ProductDescription'

const CornMasaFlourProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '016',
  IsBroadband: true,
  CookingType: '',
  Size: '',
}

export default CornMasaFlourProduct
